import { render, staticRenderFns } from "./CreditMedia.vue?vue&type=template&id=82b245ee&"
import script from "./CreditMedia.vue?vue&type=script&lang=js&"
export * from "./CreditMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports